<template>
	<div>
		<div class='tabs' id="tabs" v-if='TABLIST.length'>
			<div class="arrow arrow_left" @click="showLeft">
				<span class="iconfont icon-arrow_left"></span>
			</div>
			<div class="tab_list" ref="tabList" id="tabs_list"
				:style="'left:'+tabPosX+'px'">
				<!-- <div @click='changeTab(homeTab)'
				 :class='["tab-item", "home"==TABACTIVE.code?"tab_active":""]'>
					主页
				</div> -->
				<div v-for='(item,index) in TABLIST'
				 v-dragging="{ item: item, list: TABLIST, group: 'tab' }"
				 :key='index' @click='changeTab(item)'
				 :class='["tab-item", item.id==TABACTIVE.id?"tab_active":""]'
				 @contextmenu='showMenu(index)'>
					<span>{{item.name}}</span>
					<i class="iconfont icon-close"
					 @click.stop='removeTab(index)'></i>
				</div>
			</div>
			<div class="arrow arrow_right"
				@click="showRight">
				<span class="iconfont icon-arrow_right"></span>
			</div>
		</div>
		<ul id='tabMenu'>
			<li class="tab_menuItem" @click='closeSelf'>关闭选项卡</li>
			<li class="tab_menuItem" @click='closeOthers'>关闭其他选项卡</li>
			<li class="tab_menuItem" @click='closeRight'>关闭右侧选项卡</li>
			<li class="tab_menuItem" @click='closeLeft'>关闭左侧选项卡</li>
		</ul>
	</div>
</template>

<script scoped>
	import {mapGetters} from 'vuex'
	export default {
		name: 'tabs',
		data() {
			return {
				homeTab: {
					code: 'home',
					name: 'home',
					root: 'home'
				},
				tabPosX: 0,
				moveDist: 300,
				tabsShow: false,
				closeTabIndex: null
			}
		},
		watch: {
			TABACTIVE (newVal, oldVal) {
				let data = newVal.data?newVal.data:{}
				data.name = newVal.code
				this.$router.push(data)
			},
			TABLIST (newVal, oldVal) {
				if(this.TABLIST.length && !this.tabsShow){
					this.tabsShow = true
					this.$nextTick(function(){
						window.onclick=function(e){
							//用户触发click事件就可以关闭了，因为绑定在window上，按事件冒泡处理，不会影响菜单的功能
						　　document.getElementById('tabMenu').style.display='none';
						}
					})
				}
			}
		},
		computed: {
			...mapGetters('tabs',{
				TABLIST: 'tabList',
				TABACTIVE: 'tabActive'
			})
		},
		mounted() {
			this.$dragging.$on('dragged', ({ value }) => {})
		},
		methods: {
			removeTab(index) {
				this.$store.dispatch('tabs/removeTab',index)
				.then(res => {
				}).catch(res => {
					this.$message.error = '关闭失败'
				})
			},
			changeTab(tab) {
				this.$store.dispatch('tabs/changeTab', tab)
			},
			showMenu(index) {
				var e = window.event || argument[2];
				e.preventDefault();
				let menu = document.getElementById('tabMenu')
				menu.style.left = e.clientX + 'px';
				menu.style.top = e.clientY + 'px';
				menu.style.display = 'block';
				this.closeTabIndex = index;
			},
			closeSelf() {
				if(this.closeTabIndex !== null){
					this.removeTab(this.closeTabIndex)
				}
			},
			closeOthers() {
				this.$store.dispatch('tabs/removeOtherTabs',this.closeTabIndex)
				.catch(res => {
					this.$message.error = '关闭失败'
				})
			},
			closeRight() {
				this.$store.dispatch('tabs/removeRightTabs',this.closeTabIndex)
				.catch(res => {
					this.$message.error = '关闭失败'
				})
			},
			closeLeft() {
				this.$store.dispatch('tabs/removeLeftTabs',this.closeTabIndex)
				.catch(res => {
					this.$message.error = '关闭失败'
				})
			},
			//展示左边-向右滑动
			showLeft() {
				let tabPosX = this.tabPosX + this.moveDist
				let maxTabPosX = window.getComputedStyle(
					document.getElementById('tabs_list'))
					.width
				this.tabPosX = tabPosX > 0 ? 0 : tabPosX
			},
			// 展示右边-向左滑动
			showRight() {
				let tabPosX = this.tabPosX - this.moveDist
				let tabListW = document.getElementById('tabs_list').offsetWidth
					+ 28*2
				let tabsW = document.getElementById('tabs').offsetWidth
				// this.tabPosX  = tabPosX
				this.tabPosX = tabListW + tabPosX <= tabsW
				 ? (tabsW > tabListW ? 0 : tabsW - tabListW)
				 : tabPosX
			}
		}
	};
</script>

<style type="text/less" lang="less" scoped>
	@border_color: #E7EBEF;
	@tab_color: #2C2B40;
	.arrow{
		position: absolute;
		z-index: 9;
		width: 36px;
		text-align: center;
		height: 100%;
		display: inline-block;
		cursor: pointer;
		background: #fff;
		span{
			display: inline-block;
			width: 100%;
			margin-top: 12px;
			height: 36px;
			line-height: 36px;
			&:hover{
				background: #f8f8f8;
			}
		}
	}
	.arrow_left{
		left: 0;
	}
	.arrow_right{
		right: -1px;
	}
	.tabs{
		position: relative;
		width: 100%;
		// overflow-x: hidden;
		white-space: nowrap;
		i{
			position: absolute;
			top: -6px;
			right: -7px;
			line-height: normal;
			background: #fff;
			cursor: pointer;
			color: #7688A2;
			font-size: 15px;
			border-radius: 50%;
		}
	}
	.tab_list{
		position: relative;
		display: inline-block;
		margin: 0 21px;
		transition: left 0.8s;
	}
	.tab-item{
		cursor: pointer;
		position: relative;
		display: inline-block;
        text-decoration: none;
        box-sizing: border-box;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        padding: 0 13px;
        min-width: 90px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		margin: 12px  15px 0 15px;
		color: @tab_color;
		border-top: 1px solid @border_color;
		border-left: 1px solid @border_color;
		border-right: 1px solid @border_color;
	}
	.tab_active{
		color: #fff;
		background: #2b77ef;
	}

	#tabMenu{
		display: none;
	    overflow: hidden;
	    position: absolute;
	    list-style: none;
	    padding: 0;
	    background: #fff;
	    box-shadow: 0 1px 1px #dedcdc, 1px 0 1px #cfcccc;
	    z-index: 99;
	    border-radius: 2px;
	    font-size: 12px;
	}
	.tab_menuItem{
		cursor: pointer;
		padding: 3px 10px;
		margin: 5px 0;
		&:hover{
			background: #eee;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Tabs.vue